const API_URL_BASE = process.env.REACT_APP_API_URL_BASE;

export const suffixes = {
    START: '_START',
    FAIL: '_FAIL',
    SUCCESS: '_SUCCESS',
    CANCEL: '_CANCEL'
};

export function isPartOfCurrentRoute(state, part) {
    return state && state.router && state.router.location && state.router.location.pathname && state.router.location.pathname.indexOf(part) > -1;
}

export function throwIfUndefined(maybeUndefined, name) {
    if (maybeUndefined === undefined) throw new Error((name || 'Something') + ' was undefined');
    return maybeUndefined;
}

export const actionSuffix = {
    start: (actionName) => `${throwIfUndefined(actionName, 'actionName/START')}${suffixes.START}`,
    fail: (actionName) => `${throwIfUndefined(actionName, 'actionName/FAIL')}${suffixes.FAIL}`,
    success: (actionName) => `${throwIfUndefined(actionName, 'actionName/SUCCESS')}${suffixes.SUCCESS}`,
    cancel: (actionName) => `${throwIfUndefined(actionName, 'actionName/CANCEL')}${suffixes.CANCEL}`
};

export function getActionSuffix(actionName) {
    if (!actionName) return null;
    for (const suffixValue of Object.values(suffixes)) {
        if (actionName.indexOf(suffixValue) > -1) return suffixValue;
    }
    return null;
}

export function removeActionSuffix(actionName) {
    for (const suffixValue of Object.values(suffixes)) {
        actionName = actionName.replace(suffixValue, '');
    }
    return actionName;
}

const removeLeadingSlashes = (s) => {
    while (!!s && s.startsWith('/')) s = s.substring(1);
    return s;
};
const removeTrailingSlashes = (s) => {
    while (!!s && s.endsWith('/')) s = s.substring(0, s.length - 1);
    return s;
};
/**
 *
 * @param {string} relativeUrl The relative url of the API resource - with 0...N leading slashes.
 * @returns {string} Absolute url to API resource.
 */
export function apiUrl(relativeUrl) {
    return removeTrailingSlashes(API_URL_BASE) + '/' + removeLeadingSlashes(relativeUrl);
}
